module.exports = __webpack_public_path__ + "fonts/payback_bold-webfont.7a38442a.ttf";